import React from 'react';
import { StoreList } from '../storeList/storeList';
var VirtualHubList = function (_a) {
    var virtualHub = _a.virtualHub, clickStoreWrapper = _a.clickStoreWrapper;
    return (React.createElement(StoreList, { activeStore: virtualHub, showFullDetails: false, stores: [virtualHub], clickStoreWrapper: clickStoreWrapper, isVirtualHub: true, showDistanceFromUser: false }));
};
export { VirtualHubList };
